import { useMutation } from '@tanstack/react-query';

export const getPosition = () =>
  new Promise((resolve, reject) => {
    // 1. Check if we're in a browser environment
    if (typeof window === 'undefined') {
      reject(new Error('Geolocation is not available on the server'));
      return;
    }
    // 2. Check if the Geolocation API is available in the browser
    if (!window.navigator?.geolocation) {
      reject(new Error('Geolocation API is not available in your browser'));
      return;
    }
    // 3. Request the current position
    window.navigator.geolocation.getCurrentPosition(resolve, reject);
  });

export default function useGeolocate() {
  // Pass the `getPosition` function, NOT `getPosition()`
  return useMutation(getPosition);
}
